export default __webpack_public_path__ + "static/media/personIcon.4f54ab44.svg";